import React from 'react';
import { connect } from 'react-redux';
import './TabTotals.css';

const TabTotals = (props) => {
  if (props[`${props.keySection}Ads`]) {
    const allQC = props[`${props.keySection}Ads`].qcProcess[props.campaignKey].totalQC ===  props[`${props.keySection}Ads`].qcProcess[props.campaignKey].totalAds ? 'green' : 'black';
    return (
      <small
        className={props.className}
        style={{
          color: allQC,
        }}
      >{`${ props[`${props.keySection}Ads`].qcProcess[props.campaignKey].totalQC}/${ props[`${props.keySection}Ads`].qcProcess[props.campaignKey].totalAds}`}</small>
    );
  }
  return null;
};

const mapStateToProps = (state) => {
  const newProps = Object.assign({}, {
    ...state.adComparer,
    forceUpdate: new Date(),
  });
  return newProps;
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(
  TabTotals
);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/TabTotals.js